/** Türkçe arayüz metinleri — durum kodları API'de İngilizce kalır */
export const statusLabel = (status) => STATUS_TR[status] || status;

export const STATUS_TR = {
  Success: 'Başarılı',
  Failed: 'Başarısız',
  'Appointment Created': 'Randevu oluşturuldu',
  'Info Provided': 'Bilgi verildi',
  'Appointment Requested': 'Randevu tamamlanamadı',
  Transferred: 'Aktarıldı',
  'Routed to MTS/SKS': 'MTS/SKS yönlendirme',
};

/** Primary filter options for Çağrı Kayıtları (6 outcomes + legacy Success) */
export const STATUS_FILTER_OPTIONS = [
  { value: 'all', label: 'Tüm durumlar' },
  { value: 'Appointment Created', label: statusLabel('Appointment Created') },
  { value: 'Appointment Requested', label: statusLabel('Appointment Requested') },
  { value: 'Routed to MTS/SKS', label: statusLabel('Routed to MTS/SKS') },
  { value: 'Transferred', label: statusLabel('Transferred') },
  { value: 'Info Provided', label: statusLabel('Info Provided') },
  { value: 'Failed', label: statusLabel('Failed') },
  { value: 'Success', label: `${statusLabel('Success')} (eski)` },
];

export const SCRIPT_LABEL_TR = {
  additionalComplaintsQuestion: 'İlave şikayet sorusu',
  confirmationTemplate: 'Onay cümlesi şablonu',
  afternoonNote: 'Öğleden sonra randevu notu',
  faultDurationNote: 'Arıza süresi notu',
  reminderClosing: 'Kapanış hatırlatma metni',
  transferHoldInstruction: 'Aktarım bekleme talimatı',
  postBookClosing: 'Randevu sonrası kapanış (özet tekrar yok)',
};

export const CHANNEL_TR = {
  web_panel: 'Web paneli',
  phone: 'Telefon',
};
